export default {
  SELECT_YOUR_VEHICLE: `{window.location.pathname === '/' ? 'Search' : 'Filter'} Parts for Your Vehicle`,
  SELECT_YOUR_VEHICLE_BLOCK: `{window.location.pathname === '/' ? 'Search' : 'Filter'} Parts for Your Vehicle`,
  VERIFY_FITMENT_TITLE: 'Confirm if it fits your vehicle',
};
